// Finance area: Payments & margin overview, Invoices, Gift vouchers, Premium upgrades.
export const finance = {
  overview: {
    title: "Payments & margin",
    subtitle: "Receivables, payables and the Pohoda export",
    from: "From",
    to: "To",
    receivables: "Receivables",
    overdueAr: "Overdue (AR)",
    payables: "Payables",
    overdueAp: "Overdue (AP)",
    openInvoices_one: "{{count}} open invoice",
    openInvoices_few: "{{count}} open invoices",
    openInvoices_other: "{{count}} open invoices",
    supplierInvoices_one: "{{count}} supplier invoice",
    supplierInvoices_few: "{{count}} supplier invoices",
    supplierInvoices_other: "{{count}} supplier invoices",
    accountsReceivable: "Accounts receivable",
    accountsPayable: "Accounts payable",
    nothingOutstanding: "Nothing outstanding 🎉",
    nothingToPay: "Nothing to pay",
    dueOn: "Due {{date}}",
    dueOnInline: "due {{date}}",
    noDueDate: "No due date",
    overdue: "overdue",
    supplierFallback: "Supplier",
  },
  invoices: {
    title: "Invoices",
    subtitle: "Issued invoices — proforma, final, credit notes",
    searchPlaceholder: "Search by invoice number…",
    empty: "No invoices",
    number: "Number",
    order: "Order",
    due: "Due",
    openPdf: "Open PDF",
  },
  vouchers: {
    title: "Gift Vouchers",
    subtitle: "Manage gift vouchers",
    loadError: "Error loading vouchers. Please try again.",
    searchPlaceholder: "Search by code, name, or email…",
    empty: "No vouchers found",
    stats: {
      total: "Total",
      active: "Active",
      used: "Used",
      activeValue: "Active Value",
    },
    filters: {
      all: "All",
      active: "Active",
      used: "Used",
      expired: "Expired",
    },
    statuses: {
      active: "Active",
      used: "Used",
      expired: "Expired",
    },
    table: {
      code: "Code",
      amount: "Amount",
      buyer: "Buyer",
      recipient: "Recipient",
      expires: "Expires",
    },
    expiringSoon: "Expiring soon",
    viewDetails: "View details",
    resendEmail: "Resend email",
    detail: {
      notFound: "Voucher not found or error loading data.",
      backToList: "Back to vouchers",
      title: "Voucher {{code}}",
      created: "Created {{date}}",
      detailsTitle: "Voucher Details",
      usedAt: "Used At",
      lastEmailSent: "Last Email Sent",
      buyer: "Buyer",
      recipient: "Recipient",
      recipientNamePlaceholder: "Recipient name",
      recipientEmailPlaceholder: "Recipient email",
      personalMessage: "Personal Message",
    },
  },
  premiumUpgrades: {
    title: "Premium Upgrades",
    subtitle: "Manage premium upgrade options for trips",
    newUpgrade: "New Upgrade",
    searchPlaceholder: "Search upgrades…",
    empty: "No premium upgrades found",
    badge: "Badge",
    noImage: "No img",
    confirmDelete: "Delete this upgrade?",
    badges: {
      popular: "POPULAR",
      ourTip: "OUR TIP",
      discount: "DISCOUNT",
      new: "NEW",
    },
    form: {
      newTitle: "New Premium Upgrade",
      editTitle: "Edit Premium Upgrade",
      newSubtitle: "Create a new upgrade option",
      editingSubtitle: "Editing: {{title}}",
      notFound: "Upgrade not found",
      titlePlaceholder: "e.g. Business Class Flight Upgrade",
      descriptionPlaceholder: "Describe the upgrade…",
      noBadge: "-- No badge --",
    },
  },
};
